import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MasterComponent } from './pages/master/master.component';
import { RouterModule } from '@angular/router';
import { NgxsModule } from '@ngxs/store';
import { LayoutState } from './state/layout.state';
import { SiteHeaderComponent } from './components/site-header/site-header.component';
import { MaterialModule } from '../material.module';
import { SharedModule } from '../shared/shared.module';
import { ExploreMenuComponent } from './components/explore-menu/explore-menu.component';
import { LocaleConfigModule } from '../locale-config.module';
import { LocaleMenuComponent } from './components/locale-menu/locale-menu.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MobileNavComponent } from './components/mobile-nav/mobile-nav.component';
import { NavigationModule } from '../shared/components/navigation/navigation.module';
import { BookmarksModule } from '../bookmarks/bookmarks.module';
import { SiteFooterComponent } from './components/site-footer/site-footer.component';
import { GalleryModule } from '../gallery/gallery.module';


@NgModule({
  imports: [
    SharedModule,
    MaterialModule,
    CommonModule,
    RouterModule,
    NavigationModule,
    LocaleConfigModule,
    ReactiveFormsModule,
    BookmarksModule,
    GalleryModule,
    NgxsModule.forFeature([
      LayoutState
    ])
  ],
  declarations: [
    MasterComponent,
    SiteHeaderComponent,
    ExploreMenuComponent,
    LocaleMenuComponent,
    MobileNavComponent,
    SiteFooterComponent
  ],
  exports: [MasterComponent]
})
export class LayoutModule { }
